import { render, staticRenderFns } from "./img-edit.vue?vue&type=template&id=263a1078&scoped=true"
import script from "./img-edit.vue?vue&type=script&lang=js"
export * from "./img-edit.vue?vue&type=script&lang=js"
import style0 from "./img-edit.vue?vue&type=style&index=0&id=263a1078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263a1078",
  null
  
)

export default component.exports